"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StereoVideoFrame = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const StereoImageFrame_1 = require("./StereoImageFrame");
let StereoVideoFrame = class StereoVideoFrame extends StereoImageFrame_1.StereoImageFrame {
};
exports.StereoVideoFrame = StereoVideoFrame;
exports.StereoVideoFrame = StereoVideoFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], StereoVideoFrame);
//# sourceMappingURL=StereoVideoFrame.js.map